import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { CommonParamsType } from "constants/types/common";
import { PartnerParamsType } from "constants/types/partner";
import { FC, useCallback } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import PartnerActions from "./components/PartnerActions/PartnerActions";
import PartnerTable from "./components/PartnerTable/PartnerTable";

const PARTNER_PAGE_TITLE = "Quản lý Khách hàng / Nhà cung cấp";

const PartnerWebLayout: FC = () => {
  const { params, setParams, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams<PartnerParamsType>();

  const handleFiltersChange = useCallback(
    (filters: Partial<Omit<PartnerParamsType, keyof CommonParamsType>>) => {
      setParams((prev) => ({ ...prev, ...filters, page: 1 }));
    },
    [setParams],
  );

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: PARTNER_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <PartnerActions handleSearch={handleSearch} params={params} onFilterChange={handleFiltersChange} />
          <PartnerTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default PartnerWebLayout;
